import React, { useEffect, useMemo, useState } from "react";
import "./styles.scss";
import { Accordion, Button, Card } from "react-bootstrap";
import { ReactComponent as ArrowUp } from "../../../../../../public/icons/upload-flow/arrow-up.svg";
import { ReactComponent as ArrowDown } from "../../../../../../public/icons/upload-flow/arrow-down.svg";
import MusicGenres from "../../../../shared/MusicGenres";
import Input from "../../../UploadComponents/Input";
import PreviewImage from "../../../UploadComponents/PreviewImage";
import RadioButtons from "../../../UploadComponents/RadioButtons";
import FeatureArtist from "../../../UploadComponents/FeatureArtist";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";

interface Props {
  new_track: any;
  activeCardKey: string | null;
  album: any;
  onUpdateFormData: (values: any) => void;
}

export const initialValueForTrack = (new_track: any, album: any) => ({
  title: new_track.file.name,
  label: "",
  download_link: "",
  featured_artists: [],
  description: "",
  lyrics: "clean",
  is_mastered: true,
  post_on_create: false,
  tags: album.tags,
  release_date: null,
  preview_image: album.preview_image,
});

function CollapseCard(props: Props) {
  const { new_track, activeCardKey, onUpdateFormData } = props;
  const { current_user } = useSelector(({ current_user }: any) => ({
    current_user,
  }));

  const { handleChange, setFieldError, values, isValid, errors } = useFormik({
    initialValues: initialValueForTrack(new_track, props.album),
    validationSchema: Yup.object({
      title: Yup.string().required(),
      label: Yup.string(),
      download_link: Yup.string().url(),
      featured_artists: Yup.array().of(Yup.string()).nullable(),
      description: Yup.string(),
      lyrics: Yup.string().oneOf(["clean", "explicit"]),
      is_mastered: Yup.boolean(),
      post_on_create: Yup.boolean(),
      tags: Yup.array().of(Yup.string()).nullable(),
      release_date: Yup.date().nullable(),
    }),
    onSubmit: async values => {
      try {
      } catch (err) {
        setFieldError(
          "general",
          err.response.data.errors?.map((error: any) => error.message)
        );
      }
    },
  });

  const setValue = (name: any) => (value: any) => {
    return handleChange({ target: { name, value } });
  };

  useEffect(() => {
    onUpdateFormData(values);
  }, [values]);

  return (
    <Card className="collapse-card">
      <Accordion.Toggle
        as={Card.Header}
        variant="link"
        eventKey={new_track.s3_object_key}
      >
        <p className="mb-0">{values.title}</p>
        {activeCardKey === new_track.s3_object_key ? (
          <ArrowDown width="20" height="20" />
        ) : (
          <ArrowUp width="20" height="20" />
        )}
      </Accordion.Toggle>

      <Accordion.Collapse eventKey={new_track.s3_object_key}>
        <Card.Body>
          <div className="d-block mb-4">
            <div className="d-xl-flex mt-4">
              <PreviewImage
                previewImage={values.preview_image}
                onChange={setValue("preview_image")}
                checkCoverSizeValidation
              />
              <div className="flex-grow-1 mx-3">
                <Input
                  placeholder="Title"
                  label="Title"
                  type="text"
                  name="title"
                  value={values.title}
                  onChange={handleChange}
                  required
                />
                <Input
                  placeholder="By"
                  label="By"
                  type="text"
                  disabled
                  value={current_user.username}
                />
                <Input
                  placeholder="Label"
                  label="Label"
                  type="text"
                  value={values.label}
                  name="label"
                  onChange={handleChange}
                />
                <FeatureArtist
                  onAddNewArtist={setValue("featured_artists")}
                  feature={values.featured_artists}
                />
              </div>
            </div>
          </div>

          <RadioButtons
            options={[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ]}
            index={new_track.s3_object_key}
            label="Is this Mastered?"
            name="is_mastered"
            selected={values.is_mastered}
            onChange={handleChange}
          />

          <RadioButtons
            options={[
              { label: "clean", value: "clean" },
              { label: "explicit", value: "explicit" },
            ]}
            index={new_track.s3_object_key}
            label="Lyrics:"
            name="lyrics"
            selected={values.lyrics}
            onChange={handleChange}
          />

          <Input
            placeholder="Download link"
            label="Download Link"
            type="text"
            lablePosition="top"
            name="download_link"
            value={values.download_link}
            onChange={handleChange}
          />

          <Input
            lablePosition="top"
            placeholder="description"
            label="Description"
            type="textarea"
            name="description"
            value={values.description}
            onChange={handleChange}
          />

          <div className="genres mb-5">
            <label> Genre(s):</label>
            <MusicGenres
              index={new_track.s3_object_key}
              defaultChecked={values.tags}
              onChange={setValue("tags")}
            />
          </div>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}

export default CollapseCard;
